export const INTERVAL_TIME = 30000; // 30 Sec
export const TOAST_CONFIGURATION = {autoClose: 2000, hideProgressBar: true, position: "bottom-right"};